import { GetConfigResponseType } from 'QuoteApp/services/endpoints/GetConfig';

export type StackedCoverageMap = Record<string, string[]>;

/**
 * Creates a map of stacked coverages organized by their parent coverage.
 * @param insuranceProductCoverages - Array of insurance product coverages from config
 * @returns Map where keys are parentCoverage identifiers and values are arrays of stacked coverages with the coverage type (name)
 */
export const createStackedCoverageMap = (
  insuranceProductCoverages: GetConfigResponseType['coverages']['insuranceProduct']
): StackedCoverageMap => {
  const stackedCoverageMap: StackedCoverageMap = {};

  // Filter coverages that have a parentCoverage and are stacked
  const stackedCoverages = insuranceProductCoverages.filter(
    (coverage) => coverage.parentCoverage
  );

  // Group stacked coverages by their parent coverage and add the coverage type (name) to the array
  stackedCoverages.forEach((coverage) => {
    const parentKey = coverage.parentCoverage!;

    if (!stackedCoverageMap[parentKey]) {
      stackedCoverageMap[parentKey] = [];
    }

    stackedCoverageMap[parentKey].push(coverage.coverageType);
  });

  return stackedCoverageMap;
};
